/* global window */

'use strict';

(function (angularInstance, base64Encode) {
	const service = require('../services/pmtUtilService.js');

	angularInstance.module('PinMeTo.services').service('pmtUtilService', function () {
		this.getByPath = service.getByPath;
		this.match = service.match;
		this.groupsOf = service.groupsOf;
		this.csvDownloadStream = service.csvDownloadStream(base64Encode);
		this.xlsxDownloadStream = service.xlsxDownloadStream(base64Encode);
		this.getCurrentUnixTimeStamp = service.getCurrentUnixTimeStamp;
	});
})(window.angular, window.btoa);
